import React from 'react';
const stats = [{
  value: '348',
  label: 'Word-for-word direction lines'
}, {
  value: '200+',
  label: 'Illustrated poses (260+ custom illustrations in total)'
}, {
  value: '12 min',
  label: 'Family formals, start to finish'
}, {
  value: '8 hours',
  label: 'Covered, from getting ready to the send-off'
}];
export function SocialProofBar() {
  return <section aria-label="What's inside, by the numbers" className="w-full bg-ink text-ivory" data-id="element-294" data-mp="25qrae3tpeq3j">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 py-10 sm:grid-cols-4 sm:divide-x sm:divide-gold/25" data-id="element-295" data-mp="32h0jgfsize62">
        {stats.map(stat => <div key={stat.label} className="px-4 text-center" data-id="element-296" data-mp="2thn5paxdc3fj">
            <div className="font-serif text-2xl sm:text-3xl text-gold" data-id="element-297" data-mp="2ojbzrba72d2l">{stat.value}</div>
            <div className="mt-2 text-[11px] uppercase tracking-[0.16em] text-ivory/60" data-id="element-298" data-mp="2olocna13hx8s">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}